import { CheckCircle2, Sparkles } from "lucide-react";

export default function StepPackage({ packages, addOns, packageId, setPackageId, selectedAddOns, setSelectedAddOns }) {
  const toggleAddOn = (id) => {
    setSelectedAddOns(
      selectedAddOns.includes(id)
        ? selectedAddOns.filter((x) => x !== id)
        : [...selectedAddOns, id]
    );
  };

  return (
    <div data-testid="step-package">
      <h2 className="font-heading text-2xl tracking-tight mb-6">Choose your package</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {packages.map((pkg) => (
          <button
            key={pkg.id}
            onClick={() => setPackageId(pkg.id)}
            className={`text-left card-surface p-6 hover-lift ${packageId === pkg.id ? "ring-2 ring-forest" : ""}`}
            data-testid={`book-pkg-${pkg.id}`}
          >
            <div className="flex items-start justify-between">
              <h3 className="font-heading text-xl">{pkg.name}</h3>
              {pkg.featured && (
                <span className="text-[10px] uppercase tracking-[0.22em] text-clay">Popular</span>
              )}
            </div>
            <p className="text-sm text-muted2 mt-1">{pkg.tagline}</p>
            <div className="mt-4 flex items-baseline gap-1">
              <span className="text-xs text-muted2">from</span>
              <span className="font-heading text-3xl text-ink">${pkg.price_from}</span>
            </div>
            <ul className="mt-4 space-y-1.5 text-sm">
              {pkg.highlights.slice(0, 3).map((h) => (
                <li key={h} className="flex gap-2 text-ink/80">
                  <CheckCircle2 size={14} className="text-forest mt-0.5 shrink-0" />{h}
                </li>
              ))}
            </ul>
          </button>
        ))}
      </div>

      <h3 className="font-heading text-xl tracking-tight mt-10 mb-4">Optional add-ons</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {addOns.map((a) => {
          const active = selectedAddOns.includes(a.id);
          return (
            <button
              key={a.id}
              onClick={() => toggleAddOn(a.id)}
              className={`card-surface p-4 text-left transition ${active ? "ring-2 ring-clay/60" : ""}`}
              data-testid={`book-addon-${a.id}`}
            >
              <div className="flex items-center justify-between">
                <Sparkles size={16} className={active ? "text-clay" : "text-forest"} />
                <span className="font-heading text-base">${a.price}</span>
              </div>
              <div className="mt-2 text-sm font-medium">{a.name}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
